import React, { useState } from "react";
import Chat from "components/presentation/chat/Chat";
import Model from "components/presentation/chat/model/Model";
import l from "components/util/l";
import "styles/css/presentation/Preview.css";

const Preview = ({
  flow,
  chat,
  isAdmin,
  refreshChat,
  chatRef,
  notesRef,
  selectedNote,
  currentChat,
  onClickTab,
  onClickChangeChat,
  onClickResumeChat
}) => {

  const [showRightnav, setShowRightnav] = useState(false);

  const onClickSettingsBtn = () => setShowRightnav(true)
  const onClickCollapseBtn = () => setShowRightnav(false)



  return <div id="preview"
    className="w-100 h-100 d-flex justify-content-center align-items-center position-relative">

    <div className="position-relative h-100 flex-fill">
      <Chat
        ref={chatRef}
        notesRef={notesRef}
        flow={flow}
        chat={chat}
        selectedNote={selectedNote}
        currentChat={currentChat}
        onClickTab={onClickTab}
        onClickChangeChat={onClickChangeChat}
        onClickResumeChat={onClickResumeChat}
      />
      {!showRightnav &&
        <a id="settings-btn" class="btn btn-sm btn-lighter-white px-3 d-flex align-items-center"
          onClick={onClickSettingsBtn}>
          <i class="fas fa-cog"></i>
          <label>{l("Configurar IA%PA171")}</label>
        </a>}
    </div>
    <div id="preview-rightnav"
      className={"position-relative h-100 " + (!showRightnav && "collapsed ")}>
      <div className="overflow-auto h-100">
        <Model
          flow={flow}
          chat={chat}
          isAdmin={isAdmin}
          refreshChat={refreshChat}
        />
      </div>
      {showRightnav &&
        <div id="collapse-icon" onClick={onClickCollapseBtn}><i class="fas fa-angle-right" aria-hidden="true"></i></div>
      }
    </div>
  </div>;
}

export default Preview;